import './index.scss';
import classNames from 'classnames';
import React from 'react';
import Modal from '../modal';
function GeniusModal(props) {
    const onHide = () => {
        if (props.onHide) {
            props.onHide();
        }
    };
    const modalClass = classNames({
        'wide-modal': props.wideModal,
        'white-bg': !props.alertForm,
        'alert-bg': props.alertForm,
    });
    const modalWrapperClass = classNames('genius-modal-container', {
        'modal-no-header': !props.headerContent,
    });
    const modal = (React.createElement(Modal, { id: 'genius-modal', className: modalClass, onHide: onHide, visible: props.isModalShowing },
        React.createElement("div", { className: modalWrapperClass },
            props.headerContent &&
                React.createElement(Modal.Header, { id: 'genius-modal-header' }, props.headerContent),
            React.createElement(Modal.Body, { id: 'genius-modal-body' }, props.bodyContent),
            props.footerContent &&
                React.createElement(Modal.Footer, { id: 'genius-modal-footer' }, props.footerContent))));
    return modal;
}
export default GeniusModal;
